import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormControl } from '@angular/forms';
import { AuthService } from '@app-services/auth.service';
import { Admin, Site } from '@app-models/site';
import { SiteService } from '@app-services/site.service';
import { LoadingScreenService } from '@app-services/loading-screen.service';

import { errorMessages } from '../../../../message/error';
import { checkInvalid } from 'src/app/validation';

@Component({
  selector: 'app-edit-user-setting',
  templateUrl: './edit-user-setting.component.html',
  styleUrls: ['./edit-user-setting.component.scss']
})
export class EditUserSettingComponent implements OnInit {
  e = errorMessages.TH;
  fg: FormGroup;
  admin: Admin;
  curSite: Site;
  @ViewChild('form') formElementRef: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditUserSettingComponent>,
    private as: AuthService,
    private fb: FormBuilder,
    private ss: SiteService,
    private ls: LoadingScreenService) {
    if (data) {
      if (data.currentAdmin) {
        this.admin = data.currentAdmin;
        this.fg = this.fb.group({
          name: [this.admin.name, [Validators.required]],
          phoneNumber: [this.admin.phoneNumber, [Validators.required]],
        });
      }
    }
  }

  async ngOnInit() {
    this.curSite = await this.ss.getCurrentSite();
  }

  updateAdmin() {
    console.log(this.admin);
    this.fg.markAsTouched();
    this.fg.markAsDirty();
    if (!checkInvalid([this.fg], this.formElementRef, true)) {
      this.admin.name = this.fg.get('name').value;
      this.admin.phoneNumber = this.fg.get('phoneNumber').value;
      this.ls.startLoading();
      this.ss.updateAdminInfo(this.curSite.id, this.admin, {
        name: this.admin.name, phoneNumber: this.admin.phoneNumber
      }).then((value: any) => {
        this.dialogRef.close(true);
      }).finally(() => { this.ls.stopLoading(); });
    }
  }

}
